import styled from 'styled-components';
import { color } from 'styles/pallete';

interface Children {
	paddingChildren: boolean;
}

export const container = styled.div`
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all ease 0.5s;
`;

export const content = styled.div`
	overflow: auto;
	position: relative;
	max-height: 90vh;
	border-radius: 5px;
	min-width: 300px;
	background-color: ${color.interface.white};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	transition: all ease 0.5s;

	> svg {
		position: absolute;
		top: 1.5rem;
		right: 2rem;

		transition: all ease 0.5s;

		:hover {
			transform: scale(1.1);
		}
	}

	@media (max-width: 1000px) {
		max-width: 80%;
		min-width: unset;
		max-height: 80vh;
		min-height: 200px;
		transform: translateY(-10%);
	}

	@media (max-width: 538px) {
		width: calc(100vw - 2rem);
		max-width: calc(100vw - 2rem);
		max-height: 92vh;
		transform: none;
	}
`;

export const title = styled.div`
	padding: 2rem 2rem 0 2rem;
	width: 100%;

	p {
		width: 90%;
		font-family: nunito-bold;
		color: ${color.interface.darkgray3};
		font-size: 1.5rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	@media (max-width: 538px) {
		padding: 1.5rem 1.5rem 0 1.5rem;

		p {
			width: calc(100% - 2.5rem);
			font-size: 1.4rem;
		}
	}
`;

const children = styled.div<Children>`
	padding: ${(props: any) =>
		props.paddingChildren ? '0rem 2rem 2rem 2rem' : '0'};
	width: 100%;
	transition: all ease 0.5s;

	@media (max-width: 538px) {
		padding: ${(props: any) =>
			props.paddingChildren ? '0rem 1.5rem 1.5rem 1.5rem' : '0'};
	}
`;

export const childrenWithProps = styled(children).withConfig({
	shouldForwardProp: (prop) => !['paddingChildren'].includes(prop)
})``;

interface buttonsProps {
	colorBtn: string;
}

const buttons = styled.div<buttonsProps>`
	padding: 0 2rem 2rem 2rem;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	/* overflow: auto; */

	button {
		all: unset;
		background-color: ${(props: any) => props.colorBtn};
		border-radius: 5px;
		color: ${color.interface.white};
		padding: 1rem;
		font-size: 1.3rem;
		font-weight: 600;
		cursor: pointer;
		transition: all ease 0.5s;

		:hover {
			transform: scale(1.05);
			opacity: 0.8;
		}
	}
`;

export const buttonsWithProps = styled(buttons).withConfig({
	shouldForwardProp: (prop) => !['colorBtn'].includes(prop)
})``;

export const line = styled.div`
	width: 100%;
	min-height: 1px;
	background-color: ${color.interface.lightGray2};
	margin: 0.5rem 0;
`;
